import { Component, Inject, OnInit, Type } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface IconPickerData{
  entryComponent: Type<any>
  title: string
  allIcons: any
  dataToChange: any
  positiveCallback?: (x: string) => void
}

@Component({
  selector: 'app-icon-picker',
  templateUrl: './icon-picker.component.html',
  styleUrls: ['./icon-picker.component.css']
})
export class IconPickerComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<IconPickerComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IconPickerData) { }

  ngOnInit(): void {


  }

  iconSelected(icon): void{
    this.dialogRef.close(icon)
  
  }

}
